import { createElement } from 'react';
import { Tab } from '@alifd/next';
import './index.scss';
const OadpTab = function OadpTab({ name, size, shape, excessMode, children, ...otherProps }) {
    return (createElement(Tab, Object.assign({ size: size, shape: shape, excessMode: excessMode }, otherProps), children));
};
export default OadpTab;
